import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet'

import { title as baseTitle } from '../config'

class PageTitle extends React.Component {
  constructor(props) {
    super(props)
  }

  buildTitle(title) {
  	if (title) {
  		return title + ' | ' + baseTitle
  	} else {
			return baseTitle
  	}
  }

	render() {
		return (
			<Helmet title={this.buildTitle(this.props.title)} />
		);
	}
}

export default PageTitle



// WEBPACK FOOTER //
// ./src/components/PageTitle.js